export default function isArabic(text) {
    let arabic = /[\u0600-\u06FF]/;
    let result = arabic.test(text);
    return result;
}